import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Globe } from 'lucide-react';
import { useLanguage } from '../i18nContext';

interface StaticPageLayoutProps {
  title: string;
  children: React.ReactNode;
  onBack?: () => void;
}

export default function StaticPageLayout({ title, children, onBack }: StaticPageLayoutProps) {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="min-h-screen bg-surface">
      {/* Top bar */}
      <div className="sticky top-0 z-40 bg-surface-light/90 backdrop-blur-xl border-b border-surface-border">
        <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
          {onBack ? (
            <button
              onClick={onBack}
              className="flex items-center gap-2 text-sm text-brand-700 hover:text-brand-900 transition-colors"
            >
              <ArrowLeft size={18} />
              <span className="font-medium">{language === 'en' ? 'Back' : '返回'}</span>
            </button>
          ) : (
            <Link
              to="/"
              className="flex items-center gap-2 text-sm text-brand-700 hover:text-brand-900 transition-colors"
            >
              <ArrowLeft size={18} />
              <span className="font-medium">{language === 'en' ? 'Back' : '返回'}</span>
            </Link>
          )}
          <h1 className="text-lg font-bold text-brand-900 font-serif">{title}</h1>
          <button
            onClick={() => setLanguage(language === 'en' ? 'zh' : 'en')}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm text-brand-700 hover:text-brand-900 hover:bg-surface transition-colors"
          >
            <Globe size={16} />
            <span>{language === 'en' ? '中文' : 'EN'}</span>
          </button>
        </div>
      </div>
      {/* Content */}
      <div className="max-w-5xl mx-auto px-6 py-16">
        {children}
      </div>
    </div>
  );
}
